import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import WaterIntake from "./WaterIntake";
import _ from "lodash";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const WaterIntakeController = (app) => {
  app.get("/water-intake", async ({ res, req, locals, load }) => {
    const { query } = req;

    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <WaterIntake />;
  });
};

export default WaterIntakeController;
